import { Alert, Box, Button, Container, Paper, Typography } from "@mui/material";

/**
 * Persistent auth error UI — stays visible until the user acts (no auto-redirect).
 */
export default function AuthErrorScreen({
  title,
  message,
  primaryLabel = "Try again",
  onPrimary,
  secondaryLabel,
  onSecondary,
}) {
  if (!message) return null;

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          gap: 2,
        }}
      >
        <Paper sx={{ p: 3, width: "100%" }}>
          <Typography variant="h5" gutterBottom fontWeight="bold">
            {title}
          </Typography>
          <Alert severity="error" sx={{ mb: 2, textAlign: "left" }}>
            {message}
          </Alert>
          {onPrimary ? (
            <Button variant="contained" onClick={onPrimary} fullWidth sx={{ mb: 1 }}>
              {primaryLabel}
            </Button>
          ) : null}
          {onSecondary && secondaryLabel ? (
            <Button variant="outlined" onClick={onSecondary} fullWidth>
              {secondaryLabel}
            </Button>
          ) : null}
        </Paper>
      </Box>
    </Container>
  );
}
